import { useRouter } from "next/router";
import { zephrModal } from "lib/zephr/modal";
import { ReactElement, useEffect, useState } from "react";

type ModalProviderProps = {
  children: ReactElement;
};

const AUTH_FLOW_PATHS = ["/members/login", "/members/complete-profile"];

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const router = useRouter();
  const [isCheckoutPending, setIsCheckoutPending] = useState(false);

  useEffect(() => {
    if (AUTH_FLOW_PATHS.includes(router.pathname)) {
      return;
    }

    if (!zephrModal.isPending()) {
      setIsCheckoutPending(false);
      return;
    }

    setIsCheckoutPending(true);

    const controller = new AbortController();

    void zephrModal
      .openWhenAvailable(undefined, { signal: controller.signal })
      .then((opened) => {
        if (opened || controller.signal.aborted) {
          return;
        }

        zephrModal.cancelOpenLater();
        setIsCheckoutPending(false);
      });

    return () => controller.abort();
  }, [router.pathname]);

  return isCheckoutPending ? null : children;
};
